export default __webpack_public_path__ + "static/media/pic2.b9145d2e.jpg";